export const getMemberFullName = (member) => {
  if (member.meta?.firstName) {
    return `${member.meta.firstName} ${member.meta.lastName}`
  } else {
    return member.name
  }
}
